import { IGenericType } from '@library/common/generictype';
import { Quotation } from './quotation';

export const QuotationFactory = {
    load: ( {
        shipType: quoteType,
        mode,
        hawb: fwq,
        billingparty: billingParty,
        station,
        shipper,
        consignee,
        bill_to,
        servicelevel: serviceLevel,
        calculator,
        references,
        tradeshow,
        risks,
        accessorials,
        description,
        specialinstructions: specialInstructions,
        statuses,
        attachments,
        milestones,
        movementType,
        ...others
    }: IGenericType = {} ) => {
        return new Quotation({
            ...others,
            quoteType,
            mode,
            fwq,
            billingParty,
            station,
            shipper,
            consignee,
            bill_to,
            serviceLevel,
            calculator,
            references,
            tradeshow,
            risks,
            accessorials,
            description,
            specialInstructions,
            statuses,
            attachments: [],
            milestones,
            movementType,
        });
    },

    toShip: ({
        quoteType: shipType,
        mode,
        hawb,
        billingParty: billingparty,
        station,
        shipper,
        consignee,
        bill_to,
        serviceLevel: servicelevel,
        calculator,
        references,
        tradeshow,
        risks,
        accessorials,
        description,
        specialinstructions,
        statuses,
        attachments,
        milestones,
        dtimefrom,
        dtimeto,
        ptimefrom,
        ptimeto,
        ddatefrom,
        ddateto,
        pdatefrom,
        pdateto,
        movementType,
        incoterms,
        awbType,
        shippingType,
        itemsType,
        itemized,
        containers
    }: IGenericType = {}) => {
        return {
            shipType,
            mode,
            hawb,
            billingparty,
            station,
            shipper,
            consignee,
            bill_to,
            servicelevel,
            calculator,
            references,
            tradeshow: tradeshow?.map((ts) => ({ ...ts, location: ts.location.toLowerCase() })),
            risks,
            accessorials,
            description,
            specialinstructions,
            statuses,
            attachments,
            milestones,
            dtimefrom: dtimefrom.slice(0, 5),
            dtimeto: dtimeto.slice(0, 5),
            ptimefrom: ptimefrom.slice(0, 5),
            ptimeto: ptimeto.slice(0, 5),
            ddatefrom,
            ddateto,
            pdatefrom,
            pdateto,
            movementType,
            incoterms,
            awbType,
            shippingType,
            itemsType,
            itemized,
            containers
        };
    },
};
